<template>
  <div class="types-of-cases-section">
    <!-- 头部区域 -->
    <div class="header">
      <div class="tag">FRAUD INTELLIGENCE DATABASE</div>
      <h2 class="title">Fraud Types <span class="gradient">We Investigate</span></h2>

      <!-- 居中分割线 -->
      <div class="divider-container">
        <div class="line"></div>
        <span class="square-icon">[■]</span>
        <div class="line"></div>
      </div>
    </div>

    <!-- 数据库容器（终端风格） -->
    <div class="database-container">
      <div class="db-header">
        <div class="dots">
          <span class="dot red"></span>
          <span class="dot yellow"></span>
          <span class="dot green"></span>
        </div>
        <div class="db-title">FRAUD_TYPES_database - ACTIVE_INVESTIGATION_CATEGORIES</div>
      </div>

      <!-- 表格区域 (使用 CSS Grid 模拟表格) -->
      <div class="table-grid table-header">
        <div class="col-header">FRAUD TYPE</div>
        <div class="col-header">DESCRIPTION</div>
        <div class="col-header">RISK LEVEL</div>
        <div class="col-header">RECOVERY</div>
        <div class="col-header">AVG TIME</div>
      </div>

      <div v-for="(item, index) in fraudTypes" :key="index" class="table-grid table-row">
        <div class="col-type">{{ item.type }}</div>
        <div class="col-desc">{{ item.desc }}</div>
        <div class="col-risk">
          <span class="risk-badge" :class="item.risk.toLowerCase()">
            {{ item.risk.toUpperCase() }}
          </span>
        </div>
        <div class="col-recovery">
          <span class="check-icon">✓</span> Available
        </div>
        <div class="col-time">{{ item.time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypesOfCases',
  data() {
    return {
      fraudTypes: [
        { type: 'Crypto Investment Scam', desc: 'Fake platforms promising guaranteed returns on crypto investments', risk: 'High', time: '5-7 days' },
        { type: 'Romance / Pig Butchering', desc: 'Long-term relationship-based fraud leading to crypto transfers', risk: 'High', time: '7-14 days' },
        { type: 'Exchange Hack / Wallet Theft', desc: 'Unauthorized access to wallets or exchange accounts', risk: 'High', time: '3-5 days' },
        { type: 'Phishing Attack', desc: 'Fake websites or emails used to steal private keys or credentials', risk: 'Med', time: '5-10 days' },
        { type: 'Rug Pull / Exit Scam', desc: 'Project developers abandon platform and take investor funds', risk: 'High', time: '7-21 days' },
        { type: 'Fake Broker / Forex Scam', desc: 'Unregulated brokers blocking withdrawals and disappearing', risk: 'High', time: '7-14 days' },
        { type: 'DeFi Smart Contract Exploit', desc: 'Malicious smart contracts draining user funds through DeFi protocols', risk: 'Med', time: '10-21 days' },
        { type: 'NFT Fraud', desc: 'Counterfeit NFT projects, marketplace fraud and stolen assets', risk: 'Low', time: '5-14 days' }
      ]
    };
  }
}
</script>

<style scoped>
.types-of-cases-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

/* 头部区域 */
.header {
  max-width: 1400px;
  margin: 0 auto 40px;
  text-align: left;
}

.tag {
  color: #00ff88;
  font-size: 0.85rem;
  letter-spacing: 2px;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: 600;
}

.title {
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

/* 分割线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 容器样式 */
.database-container {
  max-width: 1400px;
  margin: 0 auto;
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid rgba(37, 48, 69, 0.8);
  border-radius: 10px;
  padding: 20px;
  overflow: hidden;
}

.db-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(37, 48, 69, 0.8);
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.dots {
  display: flex;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.db-title {
  color: #a0b3cc;
  font-family: monospace;
  font-size: 0.95rem;
}

/* 表格 Grid 布局 */
.table-grid {
  display: grid;
  grid-template-columns: 2fr 4fr 1fr 1.5fr 1.5fr;
  gap: 15px;
  align-items: center;
  padding: 20px;
}

.table-header {
  border-bottom: 1px solid rgba(37, 48, 69, 0.8);
  padding-bottom: 15px;
}

.col-header {
  color: #00ff88;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

.table-row {
  border-bottom: 1px solid rgba(37, 48, 69, 0.3);
  font-size: 1.05rem;
}

.table-row:last-child {
  border-bottom: none;
}

.col-type {
  font-weight: 700;
  color: #fff;
}

.col-desc {
  color: #a0b3cc;
}

/* 风险等级徽章样式 */
.risk-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 1px;
  border: 1px solid;
  text-align: center;
}

.risk-badge.high {
  color: #ff5f56;
  border-color: #ff5f56;
  background: rgba(255, 95, 86, 0.1);
}

.risk-badge.med {
  color: #ffbd2e;
  border-color: #ffbd2e;
  background: rgba(255, 189, 46, 0.1);
}

.risk-badge.low {
  color: #27c93f;
  border-color: #27c93f;
  background: rgba(39, 201, 63, 0.1);
}

/* 恢复列 */
.col-recovery {
  color: #00ff88;
  display: flex;
  align-items: center;
  gap: 8px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border: 1px solid #00ff88;
  border-radius: 50%;
  font-size: 0.7rem;
}

.col-time {
  color: #a0b3cc;
}

/* 响应式适配：手机端变为堆叠布局 */
@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .db-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .db-title {
    font-size: 0.8rem;
  }

  /* 在手机端隐藏表头网格 */
  .table-header {
    display: none;
  }

  /* 每一行改为块级布局，内部变成 2x2 或堆叠 */
  .table-grid {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 20px 0;
  }

  .col-type {
    font-size: 1.3rem;
    color: #00ff88;
  }

  .col-desc {
    color: #fff;
  }

  .col-risk {
    margin-top: 10px;
  }
}
</style>